/** Feeling scale 1–5 (matches mobile app emoji row). */
export const WORKOUT_FEELING_EMOJIS = ['😫', '😐', '😊', '🙂', '🤩'] as const;

export const WORKOUT_FEELING_LABEL_KEYS = [
  'workoutDetail.feeling.labels.veryWeak',
  'workoutDetail.feeling.labels.weak',
  'workoutDetail.feeling.labels.normal',
  'workoutDetail.feeling.labels.strong',
  'workoutDetail.feeling.labels.veryStrong',
] as const;

export const WORKOUT_RPE_MIN = 0;
export const WORKOUT_RPE_MAX = 10;

/** Parse API feeling field (string or number) into 1–5 or null. */
export function parseWorkoutFeeling(raw: unknown): number | null {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 1 || n > 5) return null;
  return Math.round(n);
}

/** Parse API rpe field into 0–10 or null. */
export function parseWorkoutRpe(raw: unknown): number | null {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < WORKOUT_RPE_MIN || n > WORKOUT_RPE_MAX) return null;
  return Math.round(n);
}

type FeelingWorkoutLike = {
  total_time?: number | string | null;
  tss_actual?: number | string | null;
  feeling?: string | number | null;
  rpe?: string | number | null;
};

/** Completed workout — actual duration or TSS recorded (FIT / manual completion). */
export function isCompletedWorkout(data: FeelingWorkoutLike | null | undefined): boolean {
  if (!data) return false;
  const totalTime = data.total_time;
  if (totalTime != null && totalTime !== '' && Number(totalTime) > 0) return true;
  const tss = data.tss_actual;
  if (tss != null && tss !== '' && Number.isFinite(Number(tss))) return true;
  return false;
}

/** Athlete already recorded feeling and/or RPE on this workout. */
export function hasWorkoutFeelingRecorded(data: FeelingWorkoutLike | null | undefined): boolean {
  return parseWorkoutFeeling(data?.feeling) != null || parseWorkoutRpe(data?.rpe) != null;
}

/** Show auto-prompt bottom sheet when opening summary of a completed workout without feedback. */
export function shouldAutoPromptWorkoutFeeling(data: FeelingWorkoutLike | null | undefined): boolean {
  return isCompletedWorkout(data) && !hasWorkoutFeelingRecorded(data);
}
